import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "us.collection.admin/services";
import * as Actions from "us.collection.admin/actions";
import { CreditorApproval } from "us.collection.admin/constants/Actions";
import Common from "us.common";
import CommonAPI from "us.common/services";
import _ from "lodash";

const { $MessageBox } = Common.Components;

const { getApprovalList, addCreditorApproval } =
  API.CreditorApproval.creditorApproval;

const { creditorApprovalInfo } = Actions;

const CreditorApprovalSagas = {
  creditorApproval: {
    getCreditorApprovalList: function* (action: any) {
      const params = action?.payload?.data ?? {};

      try {
        const { data } = yield call(getApprovalList, params);
        if (Array.isArray(data?.requests)) {
          yield put(
            creditorApprovalInfo.creditorApprovalList.success(data?.requests)
          );
        } else {
          yield put(creditorApprovalInfo.creditorApprovalList.fail([]));
        }
      } catch (error) {
        yield put(creditorApprovalInfo.creditorApprovalList.fail([]));
      }
    },
    addCreditorApproval: function* (action: any) {
      try {
        const params = action?.payload?.data ?? {};
        const { data, pendingApprovalsList } = yield call(
          addCreditorApproval,
          params?.data
        );
        if (
          (data?.status === 201 || data?.status == 200) &&
          pendingApprovalsList?.status === 200
        ) {
          yield put(
            creditorApprovalInfo.creditorApprovalList.success(
              pendingApprovalsList?.data?.requests
            )
          );
          if (params?.data?.IsApproved) {
            $MessageBox(
              "success",
              `US.COLLECTION.ADMIN:CREDITOR_APPROVAL.CREDITOR_APPROVAL_SAVED`,
              "",
              ""
            );
          } else {
            $MessageBox(
              "success",
              `US.COLLECTION.ADMIN:CREDITOR_APPROVAL.CREDITOR_APPROVAL_REJECT_SUCCESS`,
              "",
              ""
            );
          }
        } else {
          yield put(creditorApprovalInfo.creditorApprovalList.success([]));

          if (params?.data?.IsApproved) {
            $MessageBox(
              "error",
              `US.COLLECTION.ADMIN:CREDITOR_APPROVAL.CREDITOR_APPROVAL_SAVED_FAILED`,
              "",
              ""
            );
          } else {
            $MessageBox(
              "error",
              `US.COLLECTION.ADMIN:CREDITOR_APPROVAL.CREDITOR_APPROVAL_REJECT_FAILED`,
              "",
              ""
            );
          }
        }
      } catch (error) {}
    },
  },
};

export default [
  takeLatest(
    CreditorApproval.GET_CREDITORS_LIST_FOR_APPROVAL,
    CreditorApprovalSagas.creditorApproval.getCreditorApprovalList
  ),
  takeLatest(
    CreditorApproval.APPROVE_CREDITOR,
    CreditorApprovalSagas.creditorApproval.addCreditorApproval
  ),
];
